export const getJSON = switchToDev(get)
export const postJSON = switchToDev(post)
export const origin =
  process.env.NODE_ENV === 'production'
    ? 'https://dreambuddy.bothrs.com'
    : 'https://syst.dreambuddy.bothrs.com'

function switchToDev(func) {
  return (url, data, options) => {
    // Froomle dev
    if (url.startsWith('https://colruyt.froomle.com')) {
      options = options || {}
      options.headers = {
        accept: 'application/json',
        'content-type': 'application/json',
        Authorization:
          'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjExLCJpc3MiOiJodHRwOi8vY29scnV5dC5mcm9vbWxlLmNvbS9hcGkvYXV0aC9zaWdudXAiLCJpYXQiOjE2MzU4NDUxNTQsImV4cCI6NDc5MTUxNTY4NywibmJmIjoxNjM1ODQ1MTU0LCJqdGkiOiI1MGNkZmUxNmMwOWJmN2U1OWUwNWNmZDJhZDk4ZmNjZSJ9.j1a8rzdtUl-XYd_t9DUi1PvJxHxeUS2bd-NS0g3EqNM',
      }
    }
    if (
      process.env.NODE_ENV !== 'production' &&
      url.startsWith('https://colruyt.froomle.com')
    ) {
      // TODO: remove this block if not needed
      // url = 'https://dev.' + url.slice(8)
      // console.log('switchDev', url)
    }

    // Localhost dev
    if (!process.browser && url.startsWith('/')) {
      url = origin + url
      // console.log('switchDev', url)
    }

    return func(url, data, options)
  }
}

// Copied from @bothrs/util/fetch because vue is not transpiling...

export function fetchJSON(url, options) {
  if (options.json) {
    options.body = JSON.stringify(options.json)
  }
  return fetch(
    url,
    Object.assign(
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
        },
      },
      options
    )
  ).then(r => r.json())
}

export function get(url, json, options) {
  options = options || {}
  options.method = 'GET'
  return fetchJSON(url, options)
}

export function post(url, json, options) {
  options = options || {}
  options.json = json
  options.method = 'POST'
  return fetchJSON(url, options)
}
